import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Grid, Typography, Box } from '@mui/material';
import Header from './components/header';
import Footer from './components/footer';
import SEOTags from './common/SEO';
import Logo from './assets/img/NGF-logo.svg';
import AboutImg from './assets/img/common/about-img.jpg'
import AboutBanner from './assets/img/banner/AboutUsBanner.jpg';


const Privacy = () => {
    const [videoLoaded, setVideoLoaded] = useState(false);
    const loadVideo = () => {
        setVideoLoaded(true);
    };
    useEffect(() => {
        SEOTags(
            "Privacy policy | Figgers Law",
            "THE LAW OFFICE OF NATLIE G. FIGGERS, PLLC, also known as FIGGERS LAW ",
            "Privacy policy | Figgers Law"
        );
    }, [])
    return (
        <>

            <Header></Header>
            <div className="about-page-hero" style={{
                backgroundImage: `url(${AboutBanner})`,
                backgroundSize: "cover",
                backgroundPosition: "right",
            }}
            >
                <div className="container">
                    <div className="section-label">THE LAW OFFICE OF NATLIE G. FIGGERS, PLLC</div>
                    <h1>PRIVACY POLICY
                    </h1>

                </div>
            </div>

            <section className="about privacy" id="about">


                <div className="container about-content" style={{ marginTop: '44px' }}>


                    <p>
                        THE LAW OFFICE OF NATLIE G. FIGGERS, PLLC, also known as FIGGERS LAW
                        (the "Firm," "we," "us," or "our"), respects your privacy. This
                        Privacy Policy explains how we collect, use, disclose, retain, and
                        protect personal information obtained through{" "}
                        <a href="https://figgerslaw.com" target="_blank" rel="noreferrer">
                            https://figgerslaw.com
                        </a>
                        , pages and forms that link to this Policy, email, telephone and
                        text communications, social media, client portals, and other
                        interactions with the Firm (collectively, the "Services").
                    </p>

                    <p>
                        This Policy applies to website visitors, prospective clients,
                        clients, authorized representatives, witnesses, vendors, and
                        others who communicate with us. A signed engagement agreement,
                        court order, or applicable professional rule may impose additional
                        or different obligations. If a signed engagement agreement
                        conflicts with this Policy regarding an existing representation,
                        the engagement agreement and applicable law control.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>1. Personal Information We Collect</h2>

                    <p>
                        The information we collect depends on how you interact with us and
                        the services you request. It may include:
                    </p>

                    <ul>
                        <li>
                            Contact and identifying information, including name, address,
                            email address, telephone number, date of birth, government
                            identification information, and online identifiers.
                        </li>

                        <li>
                            Prospective-client and legal-matter information, including
                            incident details, adverse-party names, insurance information,
                            photographs, documents, communications, and information needed
                            for conflict checks, case evaluation, or representation.
                        </li>

                        <li>
                            Sensitive information, when relevant and lawfully collected,
                            including medical, health, financial, employment, tax,
                            immigration, disability, or other information connected to a
                            legal inquiry or matter.
                        </li>

                        <li>
                            Communications and preferences, including emails, text messages,
                            call records, appointment information, language preferences,
                            consent selections, opt-out requests, and communications with
                            Firm personnel.
                        </li>

                        <li>
                            Website and device information, including Internet Protocol
                            address, browser type, device identifiers, pages viewed,
                            referring pages, approximate location derived from an IP
                            address, and cookie or analytics information.
                        </li>

                        <li>
                            Professional, business, billing, transaction, and account
                            information provided in connection with services, payments,
                            events, employment, or a business relationship.
                        </li>
                    </ul>

                    <h2 style={{ fontSize: '22px' }}>2. Sources of Information</h2>

                    <p>
                        We may collect personal information directly from you; from a
                        person you authorize; through website forms, text messages, email,
                        calls, portals, or social media; from service providers; from
                        referral sources and other attorneys; from insurers, medical
                        providers, employers, courts, government agencies, witnesses,
                        opposing parties, or other persons involved in a legal matter; and
                        from public records or publicly available sources.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>3. How We Use Personal Information</h2>

                    <ul>
                        <li>
                            To respond to inquiries, conduct preliminary conflict and case
                            screening, schedule consultations, and determine whether the
                            Firm can consider or accept a matter.
                        </li>

                        <li>
                            To provide legal services, communicate about a matter,
                            investigate facts, obtain records, manage deadlines, process
                            documents, administer accounts, and comply with a signed
                            engagement agreement.
                        </li>

                        <li>
                            To operate, maintain, secure, troubleshoot, personalize, and
                            improve the Services and the Firm's business operations.
                        </li>

                        <li>
                            To send service, account, appointment, case, security,
                            educational, event, or marketing communications when permitted
                            by law and consistent with your choices.
                        </li>

                        <li>
                            To prevent fraud, misuse, security incidents, unlawful activity,
                            or threats to persons, systems, property, or rights.
                        </li>

                        <li>
                            To comply with professional obligations, court rules, legal
                            process, recordkeeping duties, and applicable law; establish or
                            defend legal claims; and enforce our agreements and policies.
                        </li>

                        <li>
                            To create aggregated or deidentified information that cannot
                            reasonably be linked to an individual and use it for lawful
                            operational, research, security, or analytical purposes.
                        </li>
                    </ul>

                    <p>
                        We may use technology tools, including automated or AI-assisted
                        tools, to route inquiries, support administrative work, improve
                        security, or assist Firm personnel. Information connected to a
                        legal matter remains subject to applicable professional obligations
                        and any separate disclosure or consent governing the Firm's use of
                        third-party AI tools.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>4. Cookies, Analytics, and Advertising</h2>

                    <p>
                        The Services may use cookies, pixels, log files, analytics tools,
                        and similar technologies to remember preferences, understand
                        website activity, measure advertising, prevent fraud, and improve
                        performance. Some analytics or advertising providers may receive
                        device identifiers, IP addresses, or online activity information.
                        Depending on applicable law, certain advertising disclosures may
                        be treated as a sale, sharing, or targeted advertising even when
                        no money changes hands.
                    </p>

                    <p>
                        You may be able to manage cookies through your browser or a
                        cookie-preference tool displayed on the Site. Blocking cookies may
                        affect some features. We do not use SMS opt-in information or
                        text-message consent for third-party advertising audiences.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>5. How We Disclose Personal Information</h2>

                    <p>
                        We may disclose personal information only as reasonably necessary
                        for the purposes described in this Policy, including to:
                    </p>

                    <ul>
                        <li>
                            Service providers that perform functions for the Firm, such as
                            website hosting, cloud storage, cybersecurity, case management,
                            document signing, payment processing, email,
                            telecommunications, SMS delivery, analytics, and professional
                            support. They may use the information only to perform services
                            for us or as otherwise permitted by contract and law.
                        </li>

                        <li>
                            Attorneys, law firms, experts, consultants, medical providers,
                            insurers, courts, mediators, vendors, witnesses, opposing
                            parties, or other persons involved in evaluating or handling a
                            legal matter, when authorized, reasonably necessary, or permitted
                            by law and professional obligations.
                        </li>

                        <li>
                            Professional advisers, auditors, insurers, financial
                            institutions, and regulators as reasonably necessary for their
                            services or our compliance obligations.
                        </li>

                        <li>
                            Government authorities, courts, law enforcement, or private
                            parties when required by law, legal process, a professional
                            duty, or reasonably necessary to protect rights, safety,
                            property, or the integrity of the Services.
                        </li>

                        <li>
                            A successor or potential successor in connection with a lawful
                            merger, reorganization, financing, or transfer of part of the
                            Firm's operations, subject to appropriate confidentiality
                            protections and professional obligations.
                        </li>

                        <li>
                            Other recipients at your direction or with your consent.
                        </li>
                    </ul>

                    <p>
                        We do not sell personal information for money. Online analytics or
                        advertising disclosures may be regulated as a sale, sharing, or
                        targeted advertising under some state laws. Mobile information and
                        SMS opt-in data are subject to the additional limitations in
                        Section 6.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>6. SMS and Text Messaging Privacy and Consent</h2>

                    <p>
                        When you affirmatively opt in, you consent to receive SMS or
                        similar text messages from Figgers Law at the mobile number you
                        provide. We offer two separate SMS programs, and you may choose
                        either, both, or neither:
                    </p>

                    <ol>
                        <li>
                            consultation and matter-related messages, including intake and
                            conflict follow-up, scheduling, appointment reminders, document
                            and electronic-signature requests, case or account updates,
                            billing information, deadlines, and security notices; and
                        </li>

                        <li>
                            informational and promotional messages, including legal
                            information, Firm announcements, community events, seminars,
                            review requests, and information about legal services.
                        </li>
                    </ol>

                    <p>
                        SMS consent is optional. Consent to either category is optional,
                        and declining promotional messages will not affect your ability to
                        request a consultation, hire the Firm, receive legal services, or
                        purchase any property, goods, or services. Promotional messages
                        may be sent using automated technology. Message frequency varies,
                        and recurring messages may be sent. Message and data rates may
                        apply.
                    </p>

                    <p>
                        You may opt out at any time by replying STOP. We also recognize
                        other reasonable opt-out language that clearly communicates your
                        request, including CANCEL, END, QUIT, UNSUBSCRIBE, REVOKE, or OPT
                        OUT. You may reply HELP for more information or contact us at the
                        telephone number or email address listed below. We may send one
                        message confirming an opt-out request. An opt-out may stop
                        automated matter-related messages as well as marketing texts, so
                        you may need to use another approved communication method.
                    </p>

                    <p>
                        <strong>SMS PRIVACY COMMITMENT.</strong> No mobile information will
                        be shared with third parties or affiliates for marketing or
                        promotional purposes. All disclosure categories above exclude
                        text-messaging originator opt-in data and consent; this information
                        will not be shared with third parties, except telecommunications
                        and messaging service providers solely to deliver messages on our
                        behalf, persons you authorize, or when required by law. Those
                        recipients may not use the information for their own marketing or
                        promotional purposes.
                    </p>

                    <p>
                        You represent that you are the subscriber or customary user of the
                        mobile number provided, or are authorized to consent for that
                        number. Please notify us promptly if the number is changed,
                        disconnected, or reassigned. Wireless carriers are not responsible
                        for delayed or undelivered messages.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>7. Legal Confidentiality and Attorney-Client Relationship</h2>

                    <p>
                        Submitting information through the Services does not by itself
                        create an attorney-client relationship or obligate the Firm to
                        accept a matter. The Firm does not intend to undertake
                        representation unless and until the Firm and the client execute a
                        written engagement agreement or the Firm otherwise clearly agrees
                        in writing to represent the client. Until then, you remain
                        responsible for protecting all claims, rights, and deadlines.
                    </p>

                    <p>
                        The Firm handles prospective-client and client information
                        consistent with applicable professional obligations. Nevertheless,
                        ordinary website forms, email, and text messaging may not be
                        encrypted. Do not send unnecessary medical records, Social
                        Security numbers, financial account information, settlement
                        authority, or other highly sensitive information unless the Firm
                        requests it through an approved method.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>8. Your Choices and Privacy Rights</h2>

                    <p>
                        You may ask us to update inaccurate contact information, change
                        communication preferences, or stop marketing communications.
                        Depending on your state of residence and subject to applicable
                        exceptions, you may also have rights to request access, correction,
                        deletion, portability, or information about certain uses or
                        disclosures; to opt out of certain sales, sharing, or targeted
                        advertising; or to appeal a privacy decision.
                    </p>

                    <p>
                        To submit a request, contact us using the information below and
                        describe the request. We may need to verify your identity and
                        authority. We will not unlawfully discriminate against you for
                        exercising an available privacy right. Some information may be
                        exempt from consumer privacy laws or may need to be retained
                        because of legal, ethical, evidentiary, security, or contractual
                        obligations.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>9. Information Security</h2>

                    <p>
                        We use administrative, technical, and physical safeguards that we
                        consider reasonable and appropriate to the nature of the
                        information. No system, transmission, storage method, or security
                        measure can guarantee absolute security. You are responsible for
                        using appropriate caution when communicating over the Internet,
                        email, or wireless networks.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>10. Retention</h2>

                    <p>
                        We retain personal information for as long as reasonably necessary
                        for the purposes described in this Policy, including conflict
                        checking, case evaluation, legal services,
                        professional-responsibility obligations, evidence preservation,
                        dispute resolution, security, accounting, and compliance.
                        Retention periods vary based on the nature and sensitivity of the
                        information and applicable legal or contractual requirements.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>11. Children</h2>

                    <p>
                        The public portions of the Services are not directed to children
                        under 13, and we do not knowingly collect personal information
                        online directly from a child under 13 without appropriate
                        authorization. A parent, guardian, or authorized adult may provide
                        information concerning a minor when seeking legal services.
                        Contact us if you believe a child submitted information without
                        appropriate authorization.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>12. Third-Party Services and Links</h2>

                    <p>
                        The Services may link to third-party websites, platforms, maps,
                        payment services, social media, or other resources. Their privacy
                        practices are governed by their own policies. A link does not
                        necessarily mean that we endorse or control the third party.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>13. Changes to This Policy</h2>

                    <p>
                        We may update this Policy to reflect changes in our practices,
                        technology, or legal obligations. The revised Policy becomes
                        effective when posted unless a later date is stated. The effective
                        date above identifies the current version. Material changes will
                        be communicated when required by law.
                    </p>

                    <h2 style={{ fontSize: '22px' }}>14. Contact Us</h2>

                    <p>
                        For questions, privacy requests, communication-preference changes,
                        or SMS assistance, contact:
                    </p>


                    <div className="privacy-contact-box">
                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Firm</div>
                            <div className="privacy-contact-value">
                                THE LAW OFFICE OF NATLIE G. FIGGERS, PLLC
                            </div>
                        </div>

                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Website</div>
                            <div className="privacy-contact-value">
                                <a
                                    href="https://figgerslaw.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://figgerslaw.com
                                </a>
                            </div>
                        </div>

                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Email</div>
                            <div className="privacy-contact-value">
                                <a href="mailto:info@figgerslaw.com">
                                    info@figgerslaw.com
                                </a>
                            </div>
                        </div>

                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Telephone</div>
                            <div className="privacy-contact-value">
                                <a href="tel:+19544510919">(954) 451-0919</a>
                                <span className="privacy-contact-or">or</span>
                                <a href="tel:+18556435291">(855) 643-5291</a>
                            </div>
                        </div>

                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Mail</div>
                            <div className="privacy-contact-value">
                                10100 West Sample Road, Suite 300,
                                <br />
                                Coral Springs, Florida 33065
                            </div>
                        </div>
                    </div>

                </div>


            </section >
            <Footer></Footer>
        </>

    );
};

export default Privacy;
